import api from '@/services/api';
import { unwrapLeadNotificationApiData } from '@/utils/leadNotificationApiData.mjs';
import {
  normalizeBindingList,
  normalizeBindingPreview
} from '@/utils/leadNotificationBindingDisplayAdapter.mjs';

export function fetchLeadNotificationBindings() {
  return api.post('/lead-notifications/bindings/list', {}).then((res) => normalizeBindingList(unwrapLeadNotificationApiData(res, [])));
}

export function createLeadNotificationBindingQrCode(userId) {
  return api.post(`/lead-notifications/bindings/${encodeURIComponent(userId)}/qrcode`, {}).then((res) => normalizeBindingPreview(unwrapLeadNotificationApiData(res, {})));
}
